export enum ImageRefPath {
  headerBackgroundImage = "../resources/assets/header_background_min.jpg",
  me = "../resources/assets/me.png",
  logoAlexa = "../resources/assets/logoAlexa.png",
  firebase = "../resources/assets/skills/firebase.png",
  cpp = "../resources/assets/skills/cpp.png",
  gc = "../resources/assets/skills/gc.png",
  js = "../resources/assets/skills/js.png",
  python = "../resources/assets/skills/python.png",
  sql = "../resources/assets/skills/sql.png",
  swift = "../resources/assets/skills/swift.png",
}

export const headerBackgroundImage = ImageRefPath.headerBackgroundImage;
export const me_png = ImageRefPath.me;
export const logoAlexa = ImageRefPath.logoAlexa;
